/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CommunityControllerDtoPostDetailRequest model module.
 * @module model/CommunityControllerDtoPostDetailRequest
 * @version 1.0
 */
class CommunityControllerDtoPostDetailRequest {
    /**
     * Constructs a new <code>CommunityControllerDtoPostDetailRequest</code>.
     * @alias module:model/CommunityControllerDtoPostDetailRequest
     */
    constructor() { 
        
        CommunityControllerDtoPostDetailRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CommunityControllerDtoPostDetailRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CommunityControllerDtoPostDetailRequest} obj Optional instance to populate.
     * @return {module:model/CommunityControllerDtoPostDetailRequest} The populated <code>CommunityControllerDtoPostDetailRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CommunityControllerDtoPostDetailRequest();

            if (data.hasOwnProperty('postNo')) {
                obj['postNo'] = ApiClient.convertToType(data['postNo'], 'Number');
            }
            if (data.hasOwnProperty('searchString')) {
                obj['searchString'] = ApiClient.convertToType(data['searchString'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CommunityControllerDtoPostDetailRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CommunityControllerDtoPostDetailRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['searchString'] && !(typeof data['searchString'] === 'string' || data['searchString'] instanceof String)) {
            throw new Error("Expected the field `searchString` to be a primitive type in the JSON string but got " + data['searchString']);
        }

        return true;
    }


}



/**
 * @member {Number} postNo
 */
CommunityControllerDtoPostDetailRequest.prototype['postNo'] = undefined;

/**
 * @member {String} searchString
 */
CommunityControllerDtoPostDetailRequest.prototype['searchString'] = undefined;






export default CommunityControllerDtoPostDetailRequest;

